<template>
  <div class="board_write_wrap">
    <div class="board_write">
      <div class="checkPassword">
        <label>비밀번호</label>
        <input placeholder="비밀번호 " maxlength="4" v-model="password" />
        <div v-if="!passwordCheckFlag" style="padding-top: 10px; padding-left: 60px; color: rgba(235, 74, 74, 0.884); font-size: 14px">유효하지 않은 비밀번호 입니다.</div>
      </div>
      <div class="board_btn">
        <button @click="checkPassword()" class="bnt_register">확인</button>
        <router-link :to="{ name: 'list' }" class="bnt_cancel" type="button">취소</router-link>
        <!-- <button @click="back()" class="bnt_cancel">취소</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      boardLists: {},
      password: '',
      passwordCheckFlag: true,
      // pageNow: '',
      key: '',
    }
  },
  created() {
    axios
      .get('/api/consult/getOne/' + this.$route.query.id)
      .then((res) => {
        this.boardLists = res.data[0]
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    checkPassword() {
      var id = this.$route.query.id
      if (this.password == this.boardLists.password) {
        this.passwordCheckFlag = true
        if (this.$route.query.key == 'list') {
          //비밀번호 확인하고 view 화면
          this.$router.push({ name: 'view', query: { id: id } })
        } else if (this.$route.query.key == 'del') {
          //비밀번호 확인하고 삭제
          axios.delete('/api/consult/delete/' + id)
          alert('삭제 되었습니다.')
          this.$router.push({ name: 'list' })
        }
        history.replaceState({}, null, location.pathname)
      } else {
        this.passwordCheckFlag = false
      }
    },
    back() {
      this.$router.go(-1)
      // this.$router.replace(this.$route.query.redirect || '/consult/consultAsk/')
    },
  },
}
</script>

<style></style>
